import { graphql } from '../__generated__/gql';

export const GET_ALL_ASSETS = graphql(/* GraphQL */ `
  query AllAssets {
    allAssets {
      assetName
      assetId
      displayName
      regionName
      aizeLink
    }
  }
`);
